var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { mockData as documentEvents } from '@web/lib/demo/data/documentEvents';
import { filterData, getUsers, pickRandom } from '@web/lib/demo/utils';
import { DocumentInsightsEnum } from '@workalizer/shared';
import { getInsightsType } from '@workalizer/shared/services/analyticDocumentInsights';
import { getDocumentType } from '@workalizer/shared/services/processMeetingsAnalytic';
import { randomInt } from '@workalizer/shared/utils';
export var documentInsights = function (input) {
    var _a;
    var users = getUsers({
        userId: input.userId,
        orgUnitId: input.orgUnitId
    });
    var data = filterData(documentEvents, [
        {
            key: 'date',
            value: input.dateFrom,
            operator: 'gt'
        },
        {
            key: 'date',
            value: input.dateTo,
            operator: 'lt'
        },
        {
            key: 'userId',
            value: users.map(function (user) { return user.id; }),
            operator: 'in'
        }
    ]);
    var result = Object.values(DocumentInsightsEnum).reduce(function (acc, key) {
        acc[key] = [];
        return acc;
    }, {});
    var groupedDocuments = data.reduce(function (acc, event) {
        acc[event.documentId] = acc[event.documentId] || [];
        acc[event.documentId].push(__assign(__assign({}, event), { createdAt: new Date(event.createdAt), updatedAt: new Date(event.updatedAt), date: new Date(event.date), subUserId: null }));
        return acc;
    }, {});
    var _loop_1 = function (documentId, events) {
        var insightsType = getInsightsType(events[0].action);
        if (insightsType) {
            var document = (_a = data.find(function (event) { return event.documentId === Number(documentId); })) === null || _a === void 0 ? void 0 : _a.document;
            if (document) {
                result[insightsType].push({
                    id: Number(documentId),
                    type: getDocumentType(document.type),
                    title: document.title,
                    slugId: document.slugId,
                    actionCount: events.length
                });
            }
        }
    };
    for (var _i = 0, _b = Object.entries(groupedDocuments); _i < _b.length; _i++) {
        var _c = _b[_i], documentId = _c[0], events = _c[1];
        _loop_1(documentId, events);
    }
    var documentsForDerived = Object.entries(groupedDocuments)
        .map(function (_a) {
        var documentId = _a[0];
        var event = data.find(function (e) { return e.documentId === Number(documentId); });
        var document = event === null || event === void 0 ? void 0 : event.document;
        if (!document)
            return null;
        return {
            id: Number(documentId),
            type: getDocumentType(document.type),
            title: document.title,
            slugId: document.slugId
        };
    })
        .filter(function (d) { return d !== null; });
    var addRandomToInsight = function (insightKey, maxDocuments, maxCount) {
        var docs = pickRandom(documentsForDerived, randomInt(0, maxDocuments));
        docs.forEach(function (doc) {
            result[insightKey].push(__assign(__assign({}, doc), { actionCount: randomInt(1, maxCount) }));
        });
    };
    addRandomToInsight(DocumentInsightsEnum.mostCommented, randomInt(3, 8), randomInt(5, 25));
    addRandomToInsight(DocumentInsightsEnum.mostChangesSuggested, randomInt(3, 8), randomInt(3, 15));
    addRandomToInsight(DocumentInsightsEnum.unresolvedComments, randomInt(2, 6), randomInt(1, 12));
    addRandomToInsight(DocumentInsightsEnum.suggestionsPending, randomInt(2, 6), randomInt(1, 8));
    addRandomToInsight(DocumentInsightsEnum.approvalPending, randomInt(1, 4), randomInt(1, 5));
    for (var key in result) {
        result[key].sort(function (a, b) { return b.actionCount - a.actionCount; });
    }
    return result;
};
